/*eslint-disable  react/jsx-indent*/
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font,
} from '@react-pdf/renderer';
import moment from 'moment';

Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    },
    {
      src: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
      fontWeight: 'bold',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingVertical: 25,
    paddingHorizontal: 30,
    fontFamily: 'Roboto',
    fontSize: 10,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  logo: {
    width: 67,
    height: 29,
  },
  headerName: {
    color: '#4E4E4E',
    fontSize: 14,
    fontWeight: 'medium',
  },
  headerRef: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  headerRefName: {
    color: '#161616',
    fontSize: 10,
    fontWeight: 'medium',
  },
  statusSuccess: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#4A878D',
    backgroundColor: '#E2F5F6',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 24,
    textTransform: 'uppercase',
  },
  headerRefID: {
    color: '#000000',
    fontSize: 13,
    fontWeight: 'medium',
  },
  timestamp: {
    fontSize: 10,
    color: '#161616',
    fontWeight: 'medium',
  },
  section: {
    marginTop: 16,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 'medium',
    color: '#0B1C56',
    backgroundColor: '#EEF3FC',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 20,
    paddingRight: 12,
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 4,
  },
  sectionTitleText: {
    fontSize: 13,
    fontWeight: 'medium',
    color: '#0B1C56',
  },
  gridContainer: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: 12,
  },
  sectionContent: {
    paddingLeft: 20,
    paddingRight: 12,
    paddingTop: 8,
    paddingBottom: 8,
    border: '1px solid #EEF3FC',
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 24,
  },
  sectionContentSimple: {
    padding: 12,
    paddingLeft: 20,
    border: '1px solid #EEF3FC',
    borderRadius: 4,
    flexGrow: 1,
  },
  rowContainer: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 16,
  },
  columnHalf: {
    flexBasis: '50%',
    flexGrow: 1,
    flexDirection: 'column',
  },
  costItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  costItemName: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#000000',
    textTransform: 'uppercase',
  },
  costItemValue: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#000000',
  },
  spacer: {
    marginTop: 16,
  },
  dataPair: {
    flexGrow: 1,
    flexShrink: 0,
    paddingRight: 15,
    marginBottom: 10,
  },
  dataKey: {
    fontSize: 8,
    color: '#161616',
    textTransform: 'uppercase',
    fontWeight: 'semibold',
    marginBottom: 5,
  },
  dataValue: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#000000',
  },
  avatarWrapper: {
    borderRadius: '100%',
    backgroundColor: '#D9E5F8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 72,
    minHeight: 72,
  },
  avatar: {
    color: '#2A5392',
    fontSize: 32,
    fontWeight: 'semibold',
  },
  idImageContainer: {
    flexDirection: 'row',
    gap: 12,
  },
  idImage: {
    flexGrow: 1,
    flexBasis: '45%',
    height: 143,
    borderRadius: 8,
    objectFit: 'contain',
  },
  billImage: {
    width: '100%',
    height: 160,
    objectFit: 'cover',
    borderRadius: 8,
  },
  addressImageContainer: {
    flexDirection: 'row',
    gap: 12,
  },
  addressImage: {
    flexGrow: 1,
    flexBasis: '30%',
    height: 168,
    objectFit: 'cover',
  },
  mapMatchText: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#080917',
    backgroundColor: '#CECED2',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 12,
    textTransform: 'uppercase',
  },
  mapImage: {
    width: '100%',
    height: 160,
    objectFit: 'cover',
    borderRadius: 4,
  },
  livenessContent: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingHorizontal: 20,
    gap: 10,
  },
  livenessScoreContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    paddingHorizontal: 0,
  },
  livenessImage: {
    width: 130,
    height: 136,
    borderRadius: '100%',
    objectFit: 'cover',
    marginTop: 10,
  },
  scorePill: {
    fontSize: 10,
    fontWeight: 'medium',
    color: '#033971',
    backgroundColor: '#BFD3F3',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 24,
    textTransform: 'uppercase',
  },
  footer: {
    flexDirection: 'column',
    marginTop: 30,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#E4E4E6',
    alignItems: 'center',
  },
  footerTopRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 8,
  },
  footerText: {
    fontSize: 9,
    color: '#858DAA',
    fontWeight: 'bold',
    textAlign: 'center',
    width: '33%',
  },
  footerPoweredByRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 5,
  },
  poweredByText: {
    fontSize: 10,
    color: '#4A4A68',
    marginRight: 5,
  },
  footerLogo: {
    width: 30,
    height: 14,
  },
});

const DataPair = ({label, value, style = {}}) => (
  <View style={[styles.dataPair, style]}>
    <Text style={styles.dataKey}>{label}</Text>
    <Text style={styles.dataValue}>{value || '-'}</Text>
  </View>
);

export const VerificationReportDocument = ({data, logoImage, userName}) => {
  const {
    headerInfo,
    governmentData,
    ninData,
    driversLicenseData,
    businessData,
    addressInfo,
    phoneInfo,
    emailInfo,
    deviceInfo,
    ipInfo,
    timeSpent,
    sessionInfo,
    utilityBillData,
    proofOfAddressData,
    mapData,
    livenessData,
  } = data || {};
  const currentDate = moment().format('DD/MM/YYYY, hh:mmA').toUpperCase();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* --- Header --- */}
        <View style={styles.header} wrap={false}>
          {logoImage && <Image style={styles.logo} src={logoImage} />}
          <Text style={styles.headerName}>{headerInfo?.name || 'N/A'}</Text>
        </View>

        <View style={styles.headerRef} wrap={false}>
          <Text style={styles.headerRefName}>REF ID</Text>
          <Text style={styles.statusSuccess}>
            {headerInfo?.status || 'N/A'}
          </Text>
        </View>

        <View style={styles.headerRef} wrap={false}>
          <Text style={styles.headerRefID}>{headerInfo?.refId || 'N/A'}</Text>
          <Text style={styles.timestamp}>{headerInfo?.timestamp || 'N/A'}</Text>
        </View>

        {/* --- Government Data Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Government Data (BVN Basic)</Text>
          <View style={styles.sectionContent}>
            <View style={styles.avatarWrapper}>
              <Text style={styles.avatar}>
                {governmentData?.AVATAR || 'N/A'}
              </Text>
            </View>

            <View style={styles.gridContainer}>
              <DataPair
                label="First Name"
                value={governmentData?.FIRST_NAME}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Middle Name"
                value={governmentData?.MIDDLE_NAME}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Surname"
                value={governmentData?.SURNAME}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="BVN No"
                value={governmentData?.BVN_NO}
                style={{width: '25%', flexGrow: 0}}
              />

              <DataPair
                label="Gender"
                value={governmentData?.GENDER}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Birth Date"
                value={governmentData?.BIRTH_DATE}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Phone Number 1"
                value={governmentData?.PHONE_NUMBER_1}
                style={{width: '25%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* ---  Government Data (NIN) Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Government Data (NIN)</Text>
          <View style={styles.sectionContent}>
            <View style={styles.avatarWrapper}>
              <Text style={styles.avatar}>{ninData?.AVATAR || 'DA'}</Text>
            </View>

            <View style={styles.gridContainer}>
              <DataPair
                label="First Name"
                value={ninData?.FIRST_NAME || 'Abiodun'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Middle Name"
                value={ninData?.MIDDLE_NAME || 'Dauda'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Surname"
                value={ninData?.SURNAME || 'Oladapo'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="ID Number"
                value={ninData?.ID_NUMBER || '11222332223'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Phone Number"
                value={ninData?.PHONE_NUMBER || '08148812328'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Gender"
                value={ninData?.GENDER || 'Male'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Email Address"
                value={
                  ninData?.EMAIL_ADDRESS || 'Adepojulabdulrazaq26@gmail.com'
                }
                style={{width: '50%', flexGrow: 0}}
              />
              <DataPair
                label="Birth Date"
                value={ninData?.BIRTH_DATE || '1988-05-17'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Birth State"
                value={ninData?.BIRTH_STATE || 'Oyo state'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Edu Level"
                value={ninData?.EDU_LEVEL || 'B(sc)'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Spoken Lang"
                value={ninData?.SPOKEN_LANG || 'English, French'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Religion"
                value={ninData?.RELIGION || 'Islam'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Residence LGA"
                value={ninData?.RESIDENCE_LGA || 'Oyo east'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Residence State"
                value={ninData?.RESIDENCE_STATE || 'Oyo state'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Self Origin LGA"
                value={ninData?.SELF_ORIGIN_LGA || 'Oyo state'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Nationality"
                value={ninData?.NATIONALITY || 'Nigeria'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Height"
                value={ninData?.HEIGHT || '6FT2'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Profession"
                value={ninData?.PROFESSION || 'Doctor'}
                style={{width: '50%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* ---  Government Issued ID (Driver's License) Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>
            Government Issued ID (Driver&apos;s License)
          </Text>
          <View style={styles.sectionContent}>
            <View style={styles.avatarWrapper}>
              <Text style={styles.avatar}>
                {driversLicenseData?.AVATAR || 'DA'}
              </Text>
            </View>

            <View style={styles.gridContainer}>
              <DataPair
                label="First Name"
                value={driversLicenseData?.FIRST_NAME || 'Abiodun'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Middle Name"
                value={driversLicenseData?.MIDDLE_NAME || 'Dauda'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Surname"
                value={driversLicenseData?.SURNAME || 'Oladapo'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="ID Number"
                value={driversLicenseData?.ID_NUMBER || '11222332223'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Country"
                value={driversLicenseData?.COUNTRY || 'Nigeria'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Birth Date"
                value={driversLicenseData?.BIRTH_DATE || '1988-05-17'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Expiry Date"
                value={driversLicenseData?.EXPIRY_DATE || '1988-05-17'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Date Issued"
                value={driversLicenseData?.DATE_ISSUED || '1988-05-17'}
                style={{width: '25%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* --- ID IMAGE SECTION --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>ID Image</Text>
          <View style={styles.sectionContentSimple}>
            <View style={styles.idImageContainer}>
              <Image
                style={styles.idImage}
                src={
                  'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1761816022/Screenshot_2025-10-30_at_10.20.07_AM_ytm4lj.png'
                }
              />
              <Image
                style={styles.idImage}
                src={
                  'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1761816022/Screenshot_2025-10-30_at_10.20.07_AM_ytm4lj.png'
                }
              />
            </View>
          </View>
        </View>

        {/* ---  Business Data Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Business Data</Text>
          <View style={styles.sectionContent}>
            <View style={styles.avatarWrapper}>
              <Text style={styles.avatar}>{businessData?.AVATAR || 'DA'}</Text>
            </View>

            <View style={styles.gridContainer}>
              <DataPair
                label="RC-Number"
                value={businessData?.RC_NUMBER || '111123344422'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Company Name"
                value={businessData?.COMPANY_NAME || 'Dojah'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Address"
                value={businessData?.ADDRESS || 'Behind cemetry funfun area'}
                style={{width: '50%', flexGrow: 0}}
              />
              <DataPair
                label="Country"
                value={businessData?.COUNTRY || 'Nigeria'}
                style={{width: '25%', flexGrow: 0}}
              />
              <DataPair
                label="Registration Date"
                value={businessData?.REGISTRATION_DATE || '1988-05-17'}
                style={{width: '25%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* ---  Address Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Address</Text>
          <View style={styles.sectionContent}>
            <View style={styles.gridContainer}>
              <DataPair
                label="SUBMITTED ADDRESS"
                value={
                  addressInfo?.SUBMITTED_ADDRESS ||
                  'No. 7 Akinloye street, Iganmode road, Lagos Mainland, Country Kitchen, Lagos State'
                }
                style={{width: '100%', flexGrow: 0}}
              />
              <DataPair
                label="STATE"
                value={addressInfo?.STATE || 'Lagos State'}
                style={{width: '33.3%', flexGrow: 0}}
              />
              <DataPair
                label="LGA"
                value={addressInfo?.LGA || 'Eti-Osa'}
                style={{width: '33.3%', flexGrow: 0}}
              />
              <DataPair
                label="LANDMARK"
                value={addressInfo?.LANDMARK || 'Country Kitchen, Lagos State'}
                style={{width: '33.3%', flexGrow: 0}}
              />

              <DataPair
                label="GEO-LOCATION"
                value={
                  addressInfo?.LANDMARK ||
                  'LON: Not Tracked     LAT: Not Tracked'
                }
                style={{width: '100%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* ---  Utility Bill Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Utility Bill</Text>
          <View style={styles.sectionContent}>
            <View style={styles.gridContainer}>
              <DataPair
                label="SUBMITTED ADDRESS"
                value={
                  utilityBillData?.ADDRESS ||
                  'No. 7 Akinloye street, Iganmode road, Lagos Mainland, Country Kitchen, Lagos State'
                }
                style={{width: '100%', flexGrow: 0}}
              />
              <DataPair
                label="DATE"
                value={utilityBillData?.DATE || '22nd April 2023'}
                style={{width: '100%', flexGrow: 0}}
              />
              <Image
                style={styles.billImage}
                src={
                  utilityBillData?.IMAGE_URL ||
                  'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1760693928/Screenshot_2025-10-17_at_10.38.34_AM_ncgq0d.png'
                }
              />
            </View>
          </View>
        </View>

        {/* --- PROOF OF ADDRESS SECTION --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Proof of Address</Text>
          <View style={styles.sectionContentSimple}>
            <View style={styles.addressImageContainer}>
              {proofOfAddressData && proofOfAddressData.length > 0 ? (
                proofOfAddressData.map((url, index) => (
                  <Image key={index} style={styles.addressImage} src={url} />
                ))
              ) : (
                <>
                  <Image
                    style={styles.addressImage}
                    src={
                      'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1760694326/Screenshot_2025-10-17_at_10.44.42_AM_aseeoe.png'
                    }
                  />
                  <Image
                    style={styles.addressImage}
                    src={
                      'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1760694326/Screenshot_2025-10-17_at_10.44.42_AM_aseeoe.png'
                    }
                  />
                  <Image
                    style={styles.addressImage}
                    src={
                      'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1760694326/Screenshot_2025-10-17_at_10.44.42_AM_aseeoe.png'
                    }
                  />
                </>
              )}
            </View>
          </View>
        </View>

        {/* --- MAP SECTION --- */}
        <View style={styles.section} wrap={false}>
          <View style={styles.sectionTitle}>
            <Text style={styles.sectionTitleText}>Map</Text>
            <Text style={styles.mapMatchText}>
              {mapData?.match || '95% MATCH'}
            </Text>
          </View>
          <View style={styles.sectionContentSimple}>
            <Image
              style={styles.mapImage}
              src={
                mapData?.imageUrl ||
                'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1760693321/Screenshot_2025-10-17_at_10.28.26_AM_xyzd9w.png'
              }
            />
          </View>
        </View>

        {/* --- LIVENESS CHECK --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Liveness Check</Text>
          <View style={styles.sectionContentSimple}>
            <View style={styles.livenessScoreContainer}>
              <Text style={styles.scorePill}>
                {livenessData?.score || '95% LIVENESS SCORE'}
              </Text>
              <Text style={styles.scorePill}>
                {livenessData?.match || '95% IMAGE MATCH'}
              </Text>
            </View>
            <View style={styles.livenessContent}>
              <Image
                style={styles.livenessImage}
                src={
                  livenessData?.imageUrl ||
                  'https://res.cloudinary.com/dpv5lxbuy/image/upload/v1761817925/Screenshot_2025-10-30_at_10.51.54_AM_yygvwc.png'
                }
              />
            </View>
          </View>
        </View>

        {/* ---  Phone & Email Row --- */}
        <View style={styles.rowContainer} wrap={false}>
          {/* Phone Number */}
          <View style={styles.columnHalf}>
            <Text style={styles.sectionTitle}>Phone Number</Text>
            <View style={styles.sectionContentSimple}>
              <DataPair
                label=""
                value={phoneInfo?.PHONE_NUMBER || '08148812328'}
                style={{marginBottom: 0}}
              />
            </View>
          </View>

          {/* Email Address */}
          <View style={styles.columnHalf}>
            <Text style={styles.sectionTitle}>Email Address</Text>
            <View style={styles.sectionContentSimple}>
              <DataPair
                label=""
                value={
                  emailInfo?.EMAIL_ADDRESS || 'Adepojulabdulrazaq26@gmail.com'
                }
                style={{marginBottom: 0}}
              />
            </View>
          </View>
        </View>

        {/* --- Device Info Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Device Info</Text>
          <View style={styles.sectionContent}>
            <View style={styles.gridContainer}>
              <DataPair
                label="OS"
                value={deviceInfo?.OS}
                style={{width: '20%', flexGrow: 0}}
              />
              <DataPair
                label="Model"
                value={deviceInfo?.MODEL}
                style={{width: '20%', flexGrow: 0}}
              />
              <DataPair
                label="Browser"
                value={deviceInfo?.BROWSER}
                style={{width: '20%', flexGrow: 0}}
              />
              <DataPair
                label="Browser Version"
                value={deviceInfo?.BROWSER_VERSION}
                style={{width: '20%', flexGrow: 0}}
              />
              <DataPair
                label="Platform"
                value={deviceInfo?.PLATFORM}
                style={{width: '20%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* --- IP Info Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>IP Info</Text>
          <View style={styles.sectionContent}>
            <View style={styles.gridContainer}>
              <DataPair
                label="IP Address"
                value={ipInfo?.IP_ADDRESS}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="Country"
                value={ipInfo?.COUNTRY}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="Region Name"
                value={ipInfo?.REGION_NAME}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="City"
                value={ipInfo?.CITY}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="Lat"
                value={ipInfo?.LAT}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="Lon"
                value={ipInfo?.LON}
                style={{width: '16.6%', flexGrow: 0}}
              />

              <DataPair
                label="Mobile Network"
                value={ipInfo?.MOBILE_NETWORK}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="VPN Proxy"
                value={ipInfo?.VPN_PROXY}
                style={{width: '16.6%', flexGrow: 0}}
              />
              <DataPair
                label="ISP"
                value={ipInfo?.ISP}
                style={{width: '60%', flexGrow: 0}}
              />

              <DataPair
                label="Server Hosting"
                value={ipInfo?.SERVER_HOSTING}
                style={{width: '16.6%', flexGrow: 0}}
              />
            </View>
          </View>
        </View>

        {/* --- Time Spent Section --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Total Time Spent</Text>
          <View style={styles.sectionContent}>
            <DataPair
              label="Amount of time taken to process verification details"
              value={timeSpent?.TIME_SPENT}
            />
          </View>
        </View>

        {/* --- Session & Total Cost  --- */}
        <View style={styles.rowContainer} wrap={false}>
          {/* Session */}
          <View style={styles.columnHalf}>
            <Text style={styles.sectionTitle}>Session</Text>
            <View style={styles.sectionContentSimple}>
              <DataPair
                label="NUMBER OF SESSION"
                value={sessionInfo?.count || '1'}
                style={{marginBottom: 0}}
              />
            </View>
          </View>

          {/* Total Cost */}
          <View style={styles.columnHalf}>
            <Text style={styles.sectionTitle}>Total Cost</Text>
            <View style={styles.sectionContentSimple}>
              <DataPair
                label=""
                value={sessionInfo?.cost || '$80.00'}
                style={{marginBottom: 0}}
              />
            </View>
          </View>
        </View>

        {/* --- Cost Summary Breakdown --- */}
        <View style={styles.section} wrap={false}>
          <Text style={styles.sectionTitle}>Cost Summary Breakdown</Text>
          <View style={styles.sectionContentSimple}>
            <DataPair
              label="BVN BASIC"
              value={sessionInfo?.bvnCost || '$80.00'}
              style={{marginBottom: 0}}
            />
          </View>
        </View>

        {/* --- Footer --- */}
        <View style={styles.footer} wrap={false}>
          <View style={styles.footerTopRow}>
            <Text style={styles.footerText}>
              GENERATED BY: {(userName || 'N/A').toUpperCase()}
            </Text>
            <Text style={styles.footerText}>GENERATED: {currentDate}</Text>
            <Text style={styles.footerText}>DOWNLOADED: {currentDate}</Text>
          </View>

          <View style={styles.footerPoweredByRow}>
            <Text style={styles.poweredByText}>Powered by</Text>
            {logoImage && <Image style={styles.footerLogo} src={logoImage} />}
          </View>
        </View>
      </Page>
    </Document>
  );
};
